import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="mt-3">
      <Container fluid>
        <Row>
          <Col className="border-top py-3 d-flex align-items-center justify-content-center gap-3">
            <p className="mb-0">&copy; 2025 Todoister</p>
            <Link className="text-decoration-none" to="/privacy-policy">
              Privacy Policy
            </Link>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
